module.exports = __webpack_public_path__ + "img/tutorial.3fae4ddb.png";